import { Avatar } from '@hivebrite/design-system/Avatar';
import { Box } from '@hivebrite/design-system/Box';
import { Dotdotdot } from '@hivebrite/design-system/Dotdotdot';

const SIZE = 40;

export const UserName = ({ user }) => (
  <Box>
    <Box height={SIZE} width={SIZE}>
      <Avatar alt="" height={SIZE} src={user.avatar} width={SIZE} />
    </Box>
    <Box
      alignItems="flex-start"
      flex={1}
      flexDirection="row"
      justifyContent="space-between"
      maxWidth={`calc(100% - ${SIZE})`}
      pl={4}
    >
      <Box
        flex={1}
        flexDirection="column"
        height="100%"
        justifyContent="center"
        maxWidth="100%"
      >
        <Box display="block" font="body-regular-asphalt" maxWidth="100%">
          <Dotdotdot clamp={1}>{user.name}</Dotdotdot>
        </Box>
      </Box>
    </Box>
  </Box>
);
